import { RuleObject } from 'antd/lib/form';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import i18n from '~/i18n';
import { merchantContact } from '~/api/merchatContact';
import { checkEmailExists } from '~/api/contacts';
import { basicValidation } from './basicValidation';

export type Validator = RuleObject['validator'];

// const emailDuplicateCheck = (listOfEmails: string[], exceptionEmail?: string): Validator => {
//   return basicValidation((rule, value,testingMerchants035 callback) => {
//     const isEmailFound = listOfEmails?.indexOf(value) >= 0 && value !== exceptionEmail;
//     try {
//       if (isEmailFound) {
//         throw new Error(
//           i18n.t('Email already exists either in list of Cardholders, Administrators or Authorized Representatives', {
//             ns: 'validation',
//           }),
//         );
//       }
//       // else if (validateEmail(value)) {
//       //   const emailValues = await merchantContact({ email: value });
//       //   if (emailValues && emailValues.length > 0) {
//       //     throw new Error(i18n.t('Email already exists in different Merchant', { ns: 'validation' }));
//       //   }
//       // }
//       callback();
//     } catch (err) {
//       console.log((err as any).message as string);
//       callback((err as any).message as string);
//     }
//   });
// };

const validateEmail = (email: string) => {
  // Regular expression for validating email address
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
};

const emailDuplicateCheck: (contactId: string, role: string) => Validator =
  (contactId, role) => async (rule, email, callback) => {
    if (!email) {
      return callback();
    }
    try {
      const exists = await checkEmailExists({ contactId, email, role });
      if (exists) {
        throw new Error(
          i18n.t(
            'The email address you entered already exists in the application. Please use a different email address to continue.',
            { ns: 'validation' },
          ),
        );
      }
      return callback();
    } catch (err) {
      return Promise.reject(new Error((err as any).message));
    }
  };

export default emailDuplicateCheck;
